import { render } from "./edit-phone.vue?vue&type=template&id=84875a7c&scoped=true"
import script from "./edit-phone.vue?vue&type=script&lang=js"
export * from "./edit-phone.vue?vue&type=script&lang=js"

import "./edit-phone.vue?vue&type=style&index=0&id=84875a7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84875a7c"]])

export default __exports__